import _jsx from"@babel/runtime/helpers/esm/jsx";import React from'react';import PullToRefresh from'./pull-to-refresh';/**
 * Pullable:
 * Basic "pull to refresh" without the refresh.
 * Just visual feedback.
 */const Pullable=_ref=>{let{children}=_ref;return/*#__PURE__*/_jsx(PullToRefresh,{pullingContent:undefined// @ts-ignore
,refreshingContent:null},void 0,children);};export default Pullable;